module.exports = __webpack_public_path__ + "img/blog-details.156c4d43.jpg";